import Vue from 'vue';
import VueI18n from 'vue-i18n';
import Cookies from 'js-cookie';

Vue.use(VueI18n);

// Função auxiliar para verificar se é um objeto
function isObject(item: any) {
  return (item && typeof item === 'object' && !Array.isArray(item));
}

// Função para fazer merge profundo de objetos
function deepMerge(target: any, source: any) {
  const output = { ...target };
  if (isObject(target) && isObject(source)) {
    Object.keys(source).forEach((key) => {
      if (isObject(source[key])) {
        if (!(key in target)) {
          Object.assign(output, { [key]: source[key] });
        } else {
          output[key] = deepMerge(target[key], source[key]);
        }
      } else {
        Object.assign(output, { [key]: source[key] });
      }
    });
  }
  return output;
}

const locales = ['pt', 'en', 'es'];

const userLocale = navigator.language.split('-')[0];
const userLocaleCookie = Cookies.get('locale');

export const defaultLocale = () => {
  if (userLocaleCookie && locales.includes(userLocaleCookie)) {
    return userLocaleCookie;
  }
  return locales.includes(userLocale) ? userLocale : 'en';
};

// Carrega todos os arquivos JSON dentro de qualquer pasta `locales`
const requireLocales = require.context(
  '../', // ou './modules' dependendo da estrutura
  true,
  /locales\/(en|pt|es)\.json$/
);

const messages: Record<string, Record<string, any>> = {
  en: {},
  pt: {},
  es: {}
};

// Junta todas as traduções por idioma
requireLocales.keys().forEach((fileName) => {
  const locale = fileName.match(/(en|pt|es)\.json$/)?.[1];
  if (locale) {
    const message = requireLocales(fileName);
    // Merge profundo das traduções
    messages[locale] = deepMerge(messages[locale], message);
  }
});

const i18n = new VueI18n({
  locale: defaultLocale(),
  fallbackLocale: 'en',
  messages,
  silentTranslationWarn: process.env.NODE_ENV === 'production',
  silentFallbackWarn: process.env.NODE_ENV === 'production'
});

export default i18n;
